module.exports = {"Description":"MA : LLL NNNN","RedundantCharacters":" -","ValidationRegex":"^[A-Z]{3}[0-9]{4}$","TestData":{"Valid":["abc1234","ABC1234","SHD4783"],"Invalid":["ABCABC","123ABCD"]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/postal-codes-js/formats/MT.json
// module id = 4475
// module chunks = 11